import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowServiceChargeActionsMenu = ({ row, onEdit, onDelete, hasPermission }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // Default permission checker
  const checkPermission = hasPermission || (() => true);

  return (
    <>
      <IconButton onClick={handleOpen} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {checkPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit && onEdit(row);
              handleClose();
            }}
          >
            Edit
          </MenuItem>
        )}
        {checkPermission("delete") && (
          <MenuItem
            onClick={() => {
              onDelete && onDelete(row.service_charge_id || row.id);
              handleClose();
            }}
          >
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

RowServiceChargeActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  hasPermission: PropTypes.func,
};

export default RowServiceChargeActionsMenu;
